"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Cookie = _interopRequireDefault(require("../services/Cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPartner = function getPartner() {
  var defaultPartner = {
    partnerId: 1,
    partnerKey: 'Carvana',
    partnerLongName: 'Carvana',
    partnerVanityUrlName: 'notused',
    partnerWhisperNumber: '1.800.333.4554',
    isExtendedWarrantyOffered: true
  };

  var partnerJson = _Cookie.default.getCookie('PartnerObject');

  if (partnerJson) {
    try {
      var partnerFromCookie = JSON.parse(partnerJson);
      return partnerFromCookie;
    } catch (err) {
      console.log(err);
    }
  }

  return defaultPartner;
};

var _default = getPartner;
exports.default = _default;
module.exports = exports.default;